export function getFilterValues(baseImage, appliedFilters) {
    const filterValues = [];
    if (!(appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.length))
        return filterValues;
    appliedFilters.forEach(filter => {
        const filterName = filter.name.toLowerCase(); // Get the filter's name
        switch (filterName) {
            case 'blur':
                filterValues.push({
                    name: filterName,
                    value: baseImage.blurRadius(),
                });
                break;
            case 'hsl':
                filterValues.push({
                    name: 'hue',
                    value: baseImage.hue(),
                });
                filterValues.push({
                    name: 'saturation',
                    value: baseImage.saturation(),
                });
                break;
            case 'brighten':
                filterValues.push({
                    name: 'brightness',
                    value: baseImage.brightness(),
                });
                break;
            default:
                if (!filterName.includes('customfilter')) {
                    filterValues.push({
                        name: filterName,
                        value: baseImage[filterName](),
                    });
                }
        }
    });
    return filterValues;
}
export function setFilterValues(baseImage, filterValues) {
    filterValues.forEach(filter => {
        switch (filter.name) {
            case 'blur':
                baseImage.blurRadius(filter.value);
                break;
            default:
                baseImage[filter.name](filter.value);
                break;
        }
    });
}
